import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Only pages needed for donor application
import WantToDonate from './pages/WantToDonate';
import ThankYou from './pages/ThankYou';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Main donor application page */}
      <Route path="/" element={<WantToDonate />} />
      <Route path="/thank-you" element={<ThankYou />} />
    </Routes>
  );
}